import React from "react";
import { Link } from "react-router-dom";
import home from "../images/home.png";
import logo from "../images/recipeailogo.jpg";
import { useSubscription } from "../context/SubscriptionContext";

const Header = ({ title }) => {
  const { isSubscribed } = useSubscription();

  return (
    <header className="header bg-myapp-recipe-ai ">
      <div className="d-flex justify-content-between align-items-center">
        <div className="flex-grow-1">
          <h1 className="titlename-recipe-ai mb-0 text-nowrap w-75 px-3 p-3 ">
            {title}
            <span className={`sub-badge ${isSubscribed ? "badge-pro" : "badge-free"}`}>
              {isSubscribed ? "Pro" : "Free"}
            </span>
          </h1>
        </div>
        <div> {process.env.REACT_APP_ENV === "QA" && <small className="px-2">NP</small>}</div>
        <div className="px-2">
          <a href="/">
            <img src={home} alt="Logo" className="rounded" width="30" />
          </a>
        </div>
        <div className="px-2">
          <img src={logo} alt="Logo" className="rounded" width="45" />
        </div>
      </div>
    </header>
  );
};

export default Header;
